<template>
  <div>
    <div class="title_1_step text-center">2. Resumen</div>
    <div class="shceduler">Revisa los datos ingresados antes de continuar.</div>

    <div class="blue_container" style="margin-bottom:30px">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="9" class="black_text"
          >({{
            defaultSection.course_code != null
              ? defaultSection.course_code
              : " - "
          }})
          {{
            defaultSection.course_name != null
              ? defaultSection.course_name
              : " - "
          }}</v-col
        >
        <v-col cols="12" xs="12" sm="12" md="3" class="float_edit text-end">
          <a class="blue_link" @click="goToStep(1)">Editar</a>
        </v-col>
        <div class="content_resume_section">
          <div class="row_accordion">
            <div class="coluumns">
              <div class="row_accordion_left">Sede</div>
              <div class="row_accordion_right activeLink">
                {{
                  defaultSection.campus &&
                  defaultSection.campus.campus_name != null
                    ? defaultSection.campus.campus_name
                    : defaultSection.campus_name &&
                      defaultSection.campus_name != null
                    ? defaultSection.campus_name
                    : " - "
                }}
                <img class="location" src="@/assets/images/pin.svg" alt />
              </div>
            </div>

            <div class="coluumns">
              <div class="row_accordion_left">Modalidad</div>
              <div class="row_accordion_right">
                {{
                  defaultSection.modality_name != null
                    ? defaultSection.modality_name
                    : " - "
                }}
              </div>
            </div>

            <div class="coluumns">
              <div class="row_accordion_left">Frecuencia</div>
              <div class="row_accordion_right">
                {{
                  defaultSection.frequency != null
                    ? defaultSection.frequency
                    : " - "
                }}
              </div>
            </div>

            <div class="coluumns">
              <div class="row_accordion_left">Horario</div>
              <div class="row_accordion_right">
                {{
                  defaultSection.schedule != null
                    ? defaultSection.schedule
                    : " - "
                }}
              </div>
            </div>

            <div class="coluumns">
              <div class="row_accordion_left">Fecha de Inicio / Fin</div>
              <div class="row_accordion_right">
                {{
                  defaultSection.start_end_date != null
                    ? defaultSection.start_end_date
                    : " - "
                }}
              </div>
            </div>

            <div class="coluumns">
              <div class="row_accordion_left">Grupo</div>
              <div class="row_accordion_right">
                {{
                  defaultSection.classroom != null
                    ? defaultSection.classroom
                    : " - "
                }}
              </div>
            </div>
          </div>
        </div>
      </v-row>
      <div class="grayline"></div>
      <v-row>
        <v-col cols="7" xs="7" sm="7" md="9" class="black_text text-end"
          >Costo del curso</v-col
        >
        <v-col cols="5" xs="5" sm="5" md="3" class="black_text text-end"
          >{{ currencySymbol }}
          {{
            defaultSection.course_amount != null
              ? defaultSection.course_amount.toFixed(2)
              : " - "
          }}</v-col
        >

        <div
          v-if="defaultSection.book_purchase == 1"
          class="grayline"
          style="width: 96%;margin: 10px auto;"
        ></div>

        <v-col
          cols="7"
          xs="7"
          sm="7"
          md="9"
          class="black_text text-end"
          v-if="defaultSection.book_purchase == 1"
          >{{
            defaultSection
              ? defaultSection.book.book_text
                ? defaultSection.book.book_text
                : ""
              : ""
          }}</v-col
        >

        <v-col
          cols="5"
          xs="5"
          sm="5"
          md="3"
          class="black_text text-end"
          v-if="defaultSection.book_purchase == 1"
          >{{ currencySymbol + " " + defaultSection.book.book_price }}</v-col
        >

        <div
          class="grayline"
          style="width: 96%;margin: 10px auto;"
          v-if="selectedDiscounts.length"
        ></div>

        <v-col
          cols="7"
          xs="7"
          sm="7"
          md="9"
          class="black_text text-end"
          v-if="selectedDiscounts.length"
        >
          <v-icon color="primary" small @click="summary = true">help</v-icon>
          Descuento
          <div v-for="(item, index) in selectedDiscounts" :key="index">
            <div class="discount_name" v-if="item.selected">
              <span>{{
                item.discount_name + " " + item.percentage_symbol
              }}</span>
            </div>
          </div>
        </v-col>
        <v-col
          v-if="selectedDiscounts.length"
          cols="5"
          xs="5"
          sm="5"
          md="3"
          class="black_text text-end"
          >- {{ currencySymbol }} {{ grossDiscount }}
          <div v-for="(item, index) in selectedDiscounts" :key="index">
            <div class="discount_name" v-if="item.selected">
              - {{ currencySymbol + item.discount }}
            </div>
          </div>
        </v-col>

        <div class="grayline" style="width: 96%;margin: 10px auto;"></div>

        <v-col cols="7" xs="7" sm="7" md="9" class="greeb_text text-end"
          >Total a pagar</v-col
        >
        <v-col cols="5" xs="5" sm="5" md="3" class="greeb_text text-end"
          >{{ currencySymbol }} {{ totaToPay }}</v-col
        >
      </v-row>
    </div>

    <div
      class="blue_container"
      style="margin-bottom:30px"
      v-if="defaultSection.free_days && defaultSection.free_days.length > 0"
    >
      <v-col cols="12" xs="12" sm="12" md="12" class="no_padding">
        <div
          class="container_book_selected"
          style="margin-top:0;flex-direction:row;padding: 0px;"
        >
          <div class="icon_body">
            <v-icon color="primary" small>info</v-icon>
          </div>
          <div
            class="text_freedays"
            v-if="defaultSection.free_days.length == 1"
          >
            Sesión del curso distinta de la frecuencia regular:<br />{{
              freeDaysFormated(defaultSection.free_days)
            }}
          </div>
          <div class="text_freedays" v-if="defaultSection.free_days.length > 1">
            Sesiones del curso distintas de la frecuencia regular:<br />{{
              freeDaysFormated(defaultSection.free_days)
            }}
          </div>
        </div>
      </v-col>
    </div>

    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="12"
        class="text-end d-flex justify-end align-center"
      >
        <div class="return_step_top">
          <span class="selected" @click="goToStep(1)" v-if="!minor">
            <v-icon style="cursor:pointer">keyboard_arrow_left</v-icon>Anterior
          </span>
          <span class="selected" @click="goToStep(2)" v-if="minor">
            <v-icon style="cursor:pointer">keyboard_arrow_left</v-icon>Anterior
          </span>
        </div>
        <v-btn
          color="primary"
          class="btn-basic uppercase"
          @click="goToStep(3)"
          v-if="!minor"
          >Continuar</v-btn
        >
        <v-btn
          color="primary"
          class="btn-basic uppercase"
          @click="goToStep(4)"
          v-if="minor"
          >Continuar</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="summary" content-class="summary" width="500">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="summary = false">
            <v-icon class="iconColor">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black_text dialog_discuont_title">
          Descuentos aplicados
        </v-card-text>
        <v-card-text class="card_discounts__body">
          <div class="dialog_discuont_applied" v-if="selectedCourseDiscount">
            {{ selectedCourseDiscount.percentage }}%
            {{ selectedCourseDiscount.discount_name }}
          </div>
          <div
            class="dialog_discount_text mb-5 mt-3"
            v-if="selectedCourseDiscount"
          >
            Le estamos aplicando el mayor descuento.
          </div>
          <div
            v-for="(item, index) in courseDiscounts()"
            :key="index"
            class="card_discounts__content"
          >
            <img
              class="card_discounts__checked_discount"
              src="@/assets/images/bluecheck.svg"
              v-if="item.selected"
            />
            <span v-else style="width:10px;heigth:8px"></span>
            <span
              class="dialog_discount_name"
              :class="verifySelectedDiscount(item.selected)"
              >{{ item.percentage }}% {{ item.discount_name }}</span
            >
          </div>
          <div
            class="dialog_discount_text mt-5"
            v-if="selectedCourseDiscount && selectedCourseDiscount.detail"
          >
            {{ selectedCourseDiscount.detail }}
          </div>

          <div
            class="dialog_discuont_applied mt-12"
            v-if="selectedBookDiscount"
          >
            {{ selectedBookDiscount.percentage }}%
            {{ selectedBookDiscount.discount_name }}
          </div>

          <div
            class="dialog_discount_text mt-3"
            v-if="selectedBookDiscount && selectedBookDiscount.detail"
          >
            {{ selectedBookDiscount.detail }}
          </div>

          <div class="dialog_discuont_applied mt-12" v-if="selectedAddtional">
            {{ selectedAddtional.percentage }}%
            {{ selectedAddtional.discount_name }}
          </div>

          <div
            class="dialog_discount_text mt-3"
            v-if="selectedAddtional && selectedAddtional.detail"
          >
            {{ selectedAddtional.detail }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import jwt from "jwt-simple";
import Helpers from "@/helpers";

export default {
  name: "Summary",
  data() {
    return {
      user: null,
      showMenu: false,
      currencySymbol: process.env.VUE_APP_CURRENCY_PEN_SYMBOL,
      summary: false,
      discountTotalList: [],
      minor: false
    };
  },
  props: ["step", "isMinor"],
  created() {
    this.user = this.$store.state.usuario;
    if (localStorage.lastCourse) {
      let course = localStorage.getItem("lastCourse");
      this.lastCourse = jwt.decode(course, this.secretKeyJwt);
    }
  },
  mounted() {
    this.minor = this.isMinor;
    this.enviarEvento();
  },
  methods: {
    ...mapMutations(["addPropToDefaultSection"]),
    enviarEvento() {
      if (typeof window.gtag === 'function') {
        window.gtag('event', '2 - Resumen', {
          'event_category': 'Matricula'
        });
      }
    },
    async goToStep(n) {
      this.addPropToDefaultSection({ total_discount: 0 });
      this.addPropToDefaultSection({ total_price: 0 });
      /* this.addPropToDefaultSection({total_discount: this.calculateDiscount()});
			this.addPropToDefaultSection({total_price: this.getTotalPrice()}); */

      //console.log(this.$store.state.usuarioMenor);
      this.$emit("goToStep", n);
    },
    verifySelectedDiscount(discount_main) {
      if (discount_main) {
        return "discounts_selected";
      } else return "";
    },

    freeDaysFormated(daysList) {
      let daysArray = daysList.map(dayFree => {
        return (
          dayFree.day +
          " " +
          dayFree.date +
          " " +
          dayFree.start_hour +
          " - " +
          dayFree.end_hour
        );
      });
      return daysArray.join(", ");
    },
    getDiscount(amount, type, value, percentaje) {
      let discount = 0;
      if (type == "PORCENTAJE") {
        discount = (amount * percentaje) / 100;
      } else {
        discount = value;
      }
      return Helpers.precise_round(discount, 2);
    },

    courseDiscounts() {
      let list = [],
        discounts = [];

      discounts = this.selectedDiscounts;

      if (discounts) {
        discounts.forEach(element => {
          if (
            element.status &&
            element.item == "DERECHOENSEÑANZA" &&
            element.quotas_payment == "AMBOS"
          ) {
            list.push(element);
          }
        });
      }
      return list;
    }
  },
  computed: {
    ...mapState(["secretKeyJwt", "defaultSection", "tokenPayzen"]),
    ...mapGetters({
      selectedDiscounts: "selectedDiscounts",
      grossDiscount: "grossDiscount",
      totaToPay: "totaToPay",
      selectedBookDiscount: "selectedBookDiscount",
      selectedCourseDiscount: "selectedCourseDiscount",
      selectedAddtional: "selectedAddtional"
    }),
    hasDiscounts() {
      if (
        this.defaultSection.discounts ||
        this.defaultSection.other_discounts
      ) {
        return true;
      } else return false;
    }
  }
};
</script>
